<template>
  <div id="app">
      <p class="news-title">我的推广码</p>
		<img :src="info.data" alt="">
		<div style="width:300px;margin: 20px auto ;">
			<!-- <van-button round block type="info" color="#fc597c" @click="saveImage">保存图片</van-button>
			<a href="https://api.tyqqhj.cn//qrcode/user_8.jpg">保存图片</a> -->
		</div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      info:[],
      id:'',
    }
  },
  components: {
  },
  created:function () {
      this.$emit('footer', false);
  },

  mounted () {
    this.recordapi();
  },
  	methods: {
		
		saveImage() {
		  const img = new Image();
		  img.src = this.info.data;
		   img.crossOrigin = 'anonymous'; // 如果图片需要跨域访问，可以设置这个属性
		  img.onload = () => {
			const canvas = document.createElement('canvas');
			canvas.width = img.width;
			canvas.height = img.height;
			const ctx = canvas.getContext('2d');
			ctx.drawImage(img, 0, 0);
			const dataURL = canvas.toDataURL('image/png');
			
			const link = document.createElement('a');
			link.href = dataURL;
			link.download = 'Ewm.png'; // 设置下载文件名
			link.click();
		  };
		},
			
			
      recordapi(){
          var that = this;
		   var userid = that.$cookieStore.getCookie('userid');
          that.$api.post("/Index/ewm",{'userid':userid}).then(res => {
            console.log(res);
            that.info = res;

          });
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Ewm.vue